var map = {
	"./de.json": 91229,
	"./en.json": 27473,
	"./es.json": 56018,
	"./ru.json": 44787,
	"./terms/de.json": 54661,
	"./terms/en.json": 7670,
	"./terms/es.json": 45946,
	"./terms/ru.json": 37851
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46761;